import styled, { css } from 'styled-components';

const mobileContainerModifier = ({ isMobileMode }) => isMobileMode && css`
  position: absolute;
  top: 70px;
  bottom: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  right: 16px;
  left: 16px;
`;

export default styled.div`
  border-radius: 6px;
  box-shadow: 0 5px 26px 0 rgba(50, 56, 62, 0.16);
  background-color: #fff;

  .react-autosuggest__section-title {
    color: #92979c;
    font-size: 14px;
    padding: 8px 25px 0;
  }

  ul {
    list-style: none;
    padding: 0;
    border-radius: 6px;
    margin: 0;
     li {
      border-bottom: solid 1px #dee6f0;
      &:first-child, &:first-child button {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
      }
      &:last-child, &:last-child button {
        border-bottom: none;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
  }

  &.react-autosuggest__suggestions-container {
    box-shadow: none;
  }

  &.react-autosuggest__suggestions-container--open {
    margin-top: 16px;
    overflow: auto;
    box-shadow: none;
    border: solid 1px #e3e9f3
    ${mobileContainerModifier};

    &.react-autosuggest__suggestion--highlighted {
      background: #f9f9f9;
    }
  }
`;

